import { render, staticRenderFns } from "./TestOrdersTableComponent.vue?vue&type=template&id=7bd8a2ce&scoped=true&"
import script from "./TestOrdersTableComponent.vue?vue&type=script&lang=js&"
export * from "./TestOrdersTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./TestOrdersTableComponent.vue?vue&type=style&index=0&id=7bd8a2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd8a2ce",
  null
  
)

export default component.exports